import { jsx } from 'react/jsx-runtime';

const UserMessage = props => {
  const {
    text
  } = props;
  return jsx("div", {
    className: "llm__row",
    children: jsx("div", {
      className: "llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6",
      children: jsx("div", {
        className: "llm__text",
        children: jsx("h2", {
          className: "llm__text-body",
          "data-text": true,
          dangerouslySetInnerHTML: {
            __html: text
          }
        })
      })
    })
  });
};

export { UserMessage };
//# sourceMappingURL=user-message.js.map
